/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.finalTrialOrderDetail.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/finalTrialOrderDetail/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
